import { gql } from '@apollo/client';
import { shareableLinkModel } from 'model';
import { basePagingResult } from '../base';

export const shareableLinkFragment = `
  id
  linkId
`;

export interface GetShareableLinksResponse {
  shareableLinks: basePagingResult<shareableLinkModel>;
}

export const GET_SHAREABLE_LINKS = gql`
  query getShareableLinks($where: ShareableLinkFilterInput, $order: [ShareableLinkSortInput!]) {
    shareableLinks(where: $where, order: $order) {
      items {
        id
        linkId
        receiverEmail
        counterPartyId
        counterParty {
          id
          name
        }
        requestorId
        requestor {
          profile {
            fullName
          }
        }
        hasResponded
        modifiedDate
      }
      totalCount
    }
  }
`;

export interface GetShareableLinkResponse {
  shareableLink?: shareableLinkModel;
}

export const GET_SHAREABLE_LINK = gql`
  query getShareableLink($where: ShareableLinkFilterInput) {
    shareableLink(where: $where) {
      ${shareableLinkFragment}
    }
  }
`;
